import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useTranslation } from 'react-i18next';

import { useCurrencyLabel } from '../hooks/use-currency-label.hook';
import { useInvoiceContext } from '../invoice.context';
import * as css from './invoice-lines-details.module.scss';

export const InvoiceLinesDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const invoice = useInvoiceContext();
  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  const currencyLabel = useCurrencyLabel(invoice.currency);

  return (
    <table className={css.invoiceLinesDetails}>
      <thead>
        <tr>
          <th>
            <Stack flex={1} alignItems="center" justifyContent="left">
              <Text fontSize={TextFontSize.Small} bold={false} uppercase>
                {t('delmonicos-shared-sdk.outputs-invoice-line.designation')}
              </Text>
            </Stack>
          </th>
          <th>
            <Stack flex={1} alignItems="center" justifyContent="left">
              <Text fontSize={TextFontSize.Small} bold={false} uppercase>
                {t('delmonicos-shared-sdk.outputs-invoice-line.metadata')}
              </Text>
            </Stack>
          </th>
          <th>
            <Stack flex={1} alignItems="center" justifyContent="center">
              <Text fontSize={TextFontSize.Small} bold={false} uppercase>
                {t('delmonicos-shared-sdk.outputs-invoice-line.quantity')}
              </Text>
            </Stack>
          </th>
          <th>
            <Stack flex={1} alignItems="center" justifyContent="right">
              <Text fontSize={TextFontSize.Small} bold={false} uppercase>
                {t('delmonicos-shared-sdk.outputs-invoice-line.unit-price-ht')}
              </Text>
            </Stack>
          </th>
          <th>
            <Stack flex={1} alignItems="center" justifyContent="right">
              <Text fontSize={TextFontSize.Small} bold={false} uppercase>
                {t('delmonicos-shared-sdk.outputs-invoice-line.total-ht')}
              </Text>
            </Stack>
          </th>
          <th>
            <Stack flex={1} alignItems="center" justifyContent="right">
              <Text fontSize={TextFontSize.Small} bold={false} uppercase>
                {t('delmonicos-shared-sdk.outputs-invoice-line.total-ttc')}
              </Text>
            </Stack>
          </th>
        </tr>
      </thead>
      <tbody>
        {invoice.lines.map((line, i) => (
          <tr key={`${line.designation}-${i}`}>
            <td>
              <Stack flex={1} alignItems="center" justifyContent="left">
                <Text bold>{line.designation}</Text>
              </Stack>
            </td>
            <td>
              <Stack flex={1} direction="column">
                {line.metadata &&
                  Object.entries(line.metadata).map(
                    ([key, value]) =>
                      !!value &&
                      (typeof value === 'string' ||
                        typeof value === 'number') && (
                        <Stack
                          key={key}
                          flex={1}
                          direction="row"
                          gap={GapEnum.XS}
                          alignItems="baseline">
                          <Text fontSize={TextFontSize.Small}>{key} :</Text>
                          <Text>{value as any}</Text>
                        </Stack>
                      ),
                  )}
              </Stack>
            </td>
            <td>
              <Stack flex={1} alignItems="center" justifyContent="center">
                {line.quantity}
              </Stack>
            </td>
            <td>
              <Stack flex={1} alignItems="center" justifyContent="right">
                {line.unitPriceHT} {currencyLabel}
              </Stack>
            </td>
            <td>
              <Stack flex={1} alignItems="center" justifyContent="right">
                {line.totalHT} {currencyLabel}
              </Stack>
            </td>
            <td>
              <Stack flex={1} alignItems="center" justifyContent="right">
                {line.totalTTC} {currencyLabel}
              </Stack>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
